export default __webpack_public_path__ + "68af26bbe7897f64c58d3844488e4fa7.png";